import MyDialog from "~/mui/MyDialog";
import { useTrans } from "~/hooks/useTrans";
import { IUrlParams } from "~/interfaces";
import { apiRemoveUser, apiLeaveProject } from "~/providers/api";
import { userStore } from "~/stores/user";
import { myUseState } from "~/hooks/myUseState";
import { useLang } from "~/hooks/useLang";

export type TSaveState = "remove" | "leave";

interface IState {
	dialogLoading: boolean;
	errorMsg: string;
}

interface IRemoveUserModal {
	userId: number;
	isInternal: boolean;
	params: IUrlParams;
	projectLastUpdate: string;
	onClose?: () => void;
	onSave?: (state: TSaveState, projectLastUpdate: string) => void;
}

export default function RemoveUserModal({
	userId = 0,
	isInternal = false,
	params = null,
	projectLastUpdate = "",
	onClose = () => {},
	onSave = () => {},
}: IRemoveUserModal) {
	const { trans } = useTrans();
	const { lang } = useLang();
	const { userData } = userStore(userState => ({
		userData: userState.user,
	}));
	const { state, updateState } = myUseState<IState>({
		dialogLoading: false,
		errorMsg: "",
	});

	async function dialogOnSave() {
		updateState({
			dialogLoading: true,
			errorMsg: "",
		});

		// internal - odstranujeme
		const removeUser = isInternal || userData.rusId !== userId;
		let errors: Array<string> = [];
		let lastUpdate = "";

		// sam sebe - ukoncuji spolupraci na klici
		if (removeUser) {
			const removeUserData = await apiRemoveUser(isInternal ? "admin" : "client", params.projectId, userId, projectLastUpdate, lang);

			errors = removeUserData.errors;
			lastUpdate = removeUserData.lastUpdate;
		} else {
			const leaveProjectData = await apiLeaveProject(params.projectId, projectLastUpdate, lang);

			errors = leaveProjectData.errors;
			lastUpdate = leaveProjectData.lastUpdate;
		}

		if (errors.length === 0) {
			onSave(removeUser ? "remove" : "leave", lastUpdate);
		} else {
			updateState({
				dialogLoading: false,
				errorMsg: errors.join(", "),
			});
		}
	}

	return <MyDialog title={trans("usersPage.removeUser")} onClose={onClose} onSave={dialogOnSave} dialogLoading={state.dialogLoading} errorMsg={state.errorMsg}
		cancelCaption={ trans("cancel") } saveCaption={ trans("usersPage.removeUser") }
	>
		<p>
			{ trans("usersPage.removeUserInfo") }
		</p>
	</MyDialog>;
}
